import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IUserProjectsFieldsFragment = {
  id?: any | null
  projectId: any
  userId?: any | null
  accessType?: Types.ProjectAccessType | null
  inviteStatus?: Types.InviteStatus | null
  isDeleted: boolean
  companyId?: any | null
  roles?: Array<any | null> | null
  teams?: Array<any | null> | null
  trades?: Array<any | null> | null
  defaultTeams?: Array<any | null> | null
  tags?: Array<any | null> | null
  responsibilities?: Array<string | null> | null
  activitiesDatePickerMode?: string | null
  lastMobileActivityFilters?: Array<{
    filterType: string
    values: Array<string | null>
  } | null> | null
  associatedCodes?: Array<{ name: string; id: string } | null> | null
  sitemapsSetupSettings?: { lastEditedSitemapId?: any | null } | null
  globesSetupSettings?: { lastEditedGlobeId?: any | null } | null
  deliveriesSettings?: {
    isFollowingFilterActive: boolean
    isMyCompanyFilterActive: boolean
    selectedGroupByOption?: Types.DeliveryListFilterType | null
    selectedFilters?: Array<{
      type?: Types.DeliveryFilterType | null
      values?: Array<string | null> | null
    } | null> | null
  } | null
  deliveryNotifications?: {
    email: boolean
    inApp: boolean
    sms: boolean
  } | null
  activityNotifications?: {
    email: boolean
    inApp: boolean
    sms: boolean
  } | null
  scannerNotifications?: { email: boolean; inApp: boolean; sms: boolean } | null
  workflowNotifications?: {
    email: boolean
    inApp: boolean
    sms: boolean
  } | null
  savedViewsSettings?: Array<{
    workflowCustomFilterId?: any | null
    uploadLogCustomFilterId?: any | null
    resourcesCustomFilterId?: any | null
    isHidden?: boolean | null
  } | null> | null
  dashboardPreferences?: {
    layout?: string | null
    widgetVisibility?: string | null
    chartTypes?: string | null
  } | null
}

export type IUserProjectForActiveUserQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  userId: Types.Scalars['ObjectId']['input']
}>

export type IUserProjectForActiveUserQuery = {
  userProject?: {
    id?: any | null
    projectId: any
    userId?: any | null
    accessType?: Types.ProjectAccessType | null
    inviteStatus?: Types.InviteStatus | null
    isDeleted: boolean
    companyId?: any | null
    roles?: Array<any | null> | null
    teams?: Array<any | null> | null
    trades?: Array<any | null> | null
    defaultTeams?: Array<any | null> | null
    tags?: Array<any | null> | null
    responsibilities?: Array<string | null> | null
    activitiesDatePickerMode?: string | null
    lastMobileActivityFilters?: Array<{
      filterType: string
      values: Array<string | null>
    } | null> | null
    associatedCodes?: Array<{ name: string; id: string } | null> | null
    sitemapsSetupSettings?: { lastEditedSitemapId?: any | null } | null
    globesSetupSettings?: { lastEditedGlobeId?: any | null } | null
    deliveriesSettings?: {
      isFollowingFilterActive: boolean
      isMyCompanyFilterActive: boolean
      selectedGroupByOption?: Types.DeliveryListFilterType | null
      selectedFilters?: Array<{
        type?: Types.DeliveryFilterType | null
        values?: Array<string | null> | null
      } | null> | null
    } | null
    deliveryNotifications?: {
      email: boolean
      inApp: boolean
      sms: boolean
    } | null
    activityNotifications?: {
      email: boolean
      inApp: boolean
      sms: boolean
    } | null
    scannerNotifications?: {
      email: boolean
      inApp: boolean
      sms: boolean
    } | null
    workflowNotifications?: {
      email: boolean
      inApp: boolean
      sms: boolean
    } | null
    savedViewsSettings?: Array<{
      workflowCustomFilterId?: any | null
      uploadLogCustomFilterId?: any | null
      resourcesCustomFilterId?: any | null
      isHidden?: boolean | null
    } | null> | null
    dashboardPreferences?: {
      layout?: string | null
      widgetVisibility?: string | null
      chartTypes?: string | null
    } | null
  } | null
}

export type IUserProjectsByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IUserProjectsByProjectIdQuery = {
  userProjects?: {
    data: Array<{
      id?: any | null
      projectId: any
      userId?: any | null
      accessType?: Types.ProjectAccessType | null
      inviteStatus?: Types.InviteStatus | null
      isDeleted: boolean
      companyId?: any | null
      roles?: Array<any | null> | null
      teams?: Array<any | null> | null
      trades?: Array<any | null> | null
      defaultTeams?: Array<any | null> | null
      tags?: Array<any | null> | null
      responsibilities?: Array<string | null> | null
      activitiesDatePickerMode?: string | null
      lastMobileActivityFilters?: Array<{
        filterType: string
        values: Array<string | null>
      } | null> | null
      associatedCodes?: Array<{ name: string; id: string } | null> | null
      sitemapsSetupSettings?: { lastEditedSitemapId?: any | null } | null
      globesSetupSettings?: { lastEditedGlobeId?: any | null } | null
      deliveriesSettings?: {
        isFollowingFilterActive: boolean
        isMyCompanyFilterActive: boolean
        selectedGroupByOption?: Types.DeliveryListFilterType | null
        selectedFilters?: Array<{
          type?: Types.DeliveryFilterType | null
          values?: Array<string | null> | null
        } | null> | null
      } | null
      deliveryNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      activityNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      scannerNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      workflowNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      savedViewsSettings?: Array<{
        workflowCustomFilterId?: any | null
        uploadLogCustomFilterId?: any | null
        resourcesCustomFilterId?: any | null
        isHidden?: boolean | null
      } | null> | null
      dashboardPreferences?: {
        layout?: string | null
        widgetVisibility?: string | null
        chartTypes?: string | null
      } | null
    }>
  } | null
}

export type IListenUserProjectsByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenUserProjectsByProjectIdSubscription = {
  userProject?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      userId?: any | null
      accessType?: Types.ProjectAccessType | null
      inviteStatus?: Types.InviteStatus | null
      isDeleted: boolean
      companyId?: any | null
      roles?: Array<any | null> | null
      teams?: Array<any | null> | null
      trades?: Array<any | null> | null
      defaultTeams?: Array<any | null> | null
      tags?: Array<any | null> | null
      responsibilities?: Array<string | null> | null
      activitiesDatePickerMode?: string | null
      lastMobileActivityFilters?: Array<{
        filterType: string
        values: Array<string | null>
      } | null> | null
      associatedCodes?: Array<{ name: string; id: string } | null> | null
      sitemapsSetupSettings?: { lastEditedSitemapId?: any | null } | null
      globesSetupSettings?: { lastEditedGlobeId?: any | null } | null
      deliveriesSettings?: {
        isFollowingFilterActive: boolean
        isMyCompanyFilterActive: boolean
        selectedGroupByOption?: Types.DeliveryListFilterType | null
        selectedFilters?: Array<{
          type?: Types.DeliveryFilterType | null
          values?: Array<string | null> | null
        } | null> | null
      } | null
      deliveryNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      activityNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      scannerNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      workflowNotifications?: {
        email: boolean
        inApp: boolean
        sms: boolean
      } | null
      savedViewsSettings?: Array<{
        workflowCustomFilterId?: any | null
        uploadLogCustomFilterId?: any | null
        resourcesCustomFilterId?: any | null
        isHidden?: boolean | null
      } | null> | null
      dashboardPreferences?: {
        layout?: string | null
        widgetVisibility?: string | null
        chartTypes?: string | null
      } | null
    } | null
  } | null
}

export type ISaveManyUserProjectsMutationVariables = Types.Exact<{
  userProjects:
    | Array<Types.InputMaybe<Types.IUserProjectInput>>
    | Types.InputMaybe<Types.IUserProjectInput>
}>

export type ISaveManyUserProjectsMutation = {
  saveManyUserProjects?: Array<{ id?: any | null } | null> | null
}

export const UserProjectsFieldsFragmentDoc = gql`
  fragment UserProjectsFields on UserProject {
    id
    projectId
    userId
    accessType
    inviteStatus
    isDeleted
    companyId
    roles
    teams
    trades
    defaultTeams
    tags
    responsibilities
    lastMobileActivityFilters {
      filterType
      values
    }
    associatedCodes {
      name
      id
    }
    activitiesDatePickerMode
    sitemapsSetupSettings {
      lastEditedSitemapId
    }
    globesSetupSettings {
      lastEditedGlobeId
    }
    deliveriesSettings {
      isFollowingFilterActive
      isMyCompanyFilterActive
      selectedGroupByOption
      selectedFilters {
        type
        values
      }
    }
    deliveryNotifications {
      email
      inApp
      sms
    }
    activityNotifications {
      email
      inApp
      sms
    }
    scannerNotifications {
      email
      inApp
      sms
    }
    workflowNotifications {
      email
      inApp
      sms
    }
    savedViewsSettings {
      workflowCustomFilterId
      uploadLogCustomFilterId
      resourcesCustomFilterId
      isHidden
    }
    dashboardPreferences {
      layout
      widgetVisibility
      chartTypes
    }
  }
`
export const UserProjectForActiveUserDocument = gql`
  query UserProjectForActiveUser($projectId: ObjectId!, $userId: ObjectId!) {
    userProject(userId: $userId, projectId: $projectId) {
      ...UserProjectsFields
    }
  }
  ${UserProjectsFieldsFragmentDoc}
`

/**
 * __useUserProjectForActiveUserQuery__
 *
 * To run a query within a React component, call `useUserProjectForActiveUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectForActiveUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectForActiveUserQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProjectForActiveUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    IUserProjectForActiveUserQuery,
    IUserProjectForActiveUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IUserProjectForActiveUserQuery,
    IUserProjectForActiveUserQueryVariables
  >(UserProjectForActiveUserDocument, options)
}
export function useUserProjectForActiveUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IUserProjectForActiveUserQuery,
    IUserProjectForActiveUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IUserProjectForActiveUserQuery,
    IUserProjectForActiveUserQueryVariables
  >(UserProjectForActiveUserDocument, options)
}
export type UserProjectForActiveUserQueryHookResult = ReturnType<
  typeof useUserProjectForActiveUserQuery
>
export type UserProjectForActiveUserLazyQueryHookResult = ReturnType<
  typeof useUserProjectForActiveUserLazyQuery
>
export type UserProjectForActiveUserQueryResult = Apollo.QueryResult<
  IUserProjectForActiveUserQuery,
  IUserProjectForActiveUserQueryVariables
>
export const UserProjectsByProjectIdDocument = gql`
  query UserProjectsByProjectId($projectId: ObjectId!) {
    userProjects(projectId: $projectId, limit: 1000000, getDeleted: true) {
      data {
        ...UserProjectsFields
      }
    }
  }
  ${UserProjectsFieldsFragmentDoc}
`

/**
 * __useUserProjectsByProjectIdQuery__
 *
 * To run a query within a React component, call `useUserProjectsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUserProjectsByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IUserProjectsByProjectIdQuery,
    IUserProjectsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IUserProjectsByProjectIdQuery,
    IUserProjectsByProjectIdQueryVariables
  >(UserProjectsByProjectIdDocument, options)
}
export function useUserProjectsByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IUserProjectsByProjectIdQuery,
    IUserProjectsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IUserProjectsByProjectIdQuery,
    IUserProjectsByProjectIdQueryVariables
  >(UserProjectsByProjectIdDocument, options)
}
export type UserProjectsByProjectIdQueryHookResult = ReturnType<
  typeof useUserProjectsByProjectIdQuery
>
export type UserProjectsByProjectIdLazyQueryHookResult = ReturnType<
  typeof useUserProjectsByProjectIdLazyQuery
>
export type UserProjectsByProjectIdQueryResult = Apollo.QueryResult<
  IUserProjectsByProjectIdQuery,
  IUserProjectsByProjectIdQueryVariables
>
export const ListenUserProjectsByProjectIdDocument = gql`
  subscription ListenUserProjectsByProjectId($projectId: ObjectId!) {
    userProject(projectId: $projectId) {
      id
      item {
        ...UserProjectsFields
      }
    }
  }
  ${UserProjectsFieldsFragmentDoc}
`

/**
 * __useListenUserProjectsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenUserProjectsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenUserProjectsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenUserProjectsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenUserProjectsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenUserProjectsByProjectIdSubscription,
    IListenUserProjectsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenUserProjectsByProjectIdSubscription,
    IListenUserProjectsByProjectIdSubscriptionVariables
  >(ListenUserProjectsByProjectIdDocument, options)
}
export type ListenUserProjectsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenUserProjectsByProjectIdSubscription
>
export type ListenUserProjectsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenUserProjectsByProjectIdSubscription>
export const SaveManyUserProjectsDocument = gql`
  mutation saveManyUserProjects($userProjects: [UserProjectInput]!) {
    saveManyUserProjects(userProjects: $userProjects) {
      id
    }
  }
`
export type ISaveManyUserProjectsMutationFn = Apollo.MutationFunction<
  ISaveManyUserProjectsMutation,
  ISaveManyUserProjectsMutationVariables
>

/**
 * __useSaveManyUserProjectsMutation__
 *
 * To run a mutation, you first call `useSaveManyUserProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManyUserProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManyUserProjectsMutation, { data, loading, error }] = useSaveManyUserProjectsMutation({
 *   variables: {
 *      userProjects: // value for 'userProjects'
 *   },
 * });
 */
export function useSaveManyUserProjectsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveManyUserProjectsMutation,
    ISaveManyUserProjectsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveManyUserProjectsMutation,
    ISaveManyUserProjectsMutationVariables
  >(SaveManyUserProjectsDocument, options)
}
export type SaveManyUserProjectsMutationHookResult = ReturnType<
  typeof useSaveManyUserProjectsMutation
>
export type SaveManyUserProjectsMutationResult =
  Apollo.MutationResult<ISaveManyUserProjectsMutation>
export type SaveManyUserProjectsMutationOptions = Apollo.BaseMutationOptions<
  ISaveManyUserProjectsMutation,
  ISaveManyUserProjectsMutationVariables
>
